import produce, { Draft } from 'immer';

import { Reducer } from 'redux';

type HandlersWithState<S> = {
  [key: string]: Reducer<S>;
};

type ActionType = {
  type: string;
  payload?: any;
};

type ImmerHandlersWithState<S> = {
  [key: string]: (draft: Draft<S>, action: ActionType) => void;
};

type CreateReducerType = <S>(
  initialState: S,
  handlers: HandlersWithState<S>
) => Reducer<S>;

type CreateImmerReducerType = <S>(
  initialState: S,
  handlers: ImmerHandlersWithState<S>
) => Reducer<S>;

export const createImmerReducer: CreateImmerReducerType =
  (initialState, handlers) =>
  (state = initialState, action) =>
    produce(state, (draft) => {
      if (action.type in handlers) {
        handlers[action.type](draft, action);
      }
    });

const createReducer: CreateReducerType =
  (initialState, handlers) =>
  (state = initialState, action) =>
    action.type in handlers ? handlers[action.type](state, action) : state;

export default createReducer;
